import { Container } from '@pixi/react'
import { useEffect, useState } from 'react'
import { Ga4EventType, ga4Info } from '../../util/GA4/index'
import { soundManager, SoundType } from '../../domain/sound/SoundManager'
import { ButtonProps } from '../menu/interface/ButtonProps'
import { Button } from '../../UI/Button'

export const SoundButtonV2 = (props: ButtonProps) => {
  const [isMute, setIsMute] = useState(soundManager.isMute())

  useEffect(() => {
    if (isMute) {
      ga4Info.addEvent(Ga4EventType.menu_close_music)
      soundManager.mute()
    }
    else {
      soundManager.unmute()
    }
  }, [isMute])

  const callback = () => {
    const newVal = !isMute
    setIsMute(newVal)
  }

  return (
    <Container position={[props.x, props.y]}>
      {isMute
        ? (
            <Button
              name="sound off Button"
              defaultView="sound_off_normal_v2"
              hoverView="sound_off_hover_v2"
              pressedView="sound_off_click_v2"
              disabledView="sound_off_unable_v2"
              x={0}
              y={0}
              width={props.width}
              height={props.height}
              key="off"
              onPressing={() => {
                soundManager.play(SoundType.buttonConfirm)
              }}
              onPress={callback}
            />
          )
        : (
            <Button
              name="sound on Button"
              defaultView="sound_on_normal_v2"
              hoverView="sound_on_hover_v2"
              pressedView="sound_on_click_v2"
              disabledView="sound_on_unable_v2"
              x={0}
              y={0}
              width={props.width}
              height={props.height}
              key="on"
              onPressing={() => {
                soundManager.play(SoundType.buttonConfirm)
              }}
              onPress={callback}
            />
          )}
    </Container>
  )
}
